import {
    IStackStyles,
    PrimaryButton,
    Stack
} from "@fluentui/react";
import React from "react";


const container: IStackStyles = {
    root: {
        marginTop: 10,
        minHeight: 500
    },
};

export const NewRelicErrorTextPage = () => {
    
    const handleClick = () => {
        try {
            throw new Error('Sample test error 1');
        } catch (err) {
            throw new Error('Sample test error 1 ', err);
        }
    };

    return (
        <div>
            <Stack styles={container} tokens={{ childrenGap: 10 }}>
                <div className="datatable-filter-demo noMaxWidthTable">
                    <PrimaryButton
                        text="Submit"
                        onClick={handleClick}
                    />
                </div>
            </Stack>
        </div>

    );
};


